import React from "react";
import Dashboard from "../components/dashboard/Dashboard";

export const DashboardPage = () => {
  return <Dashboard />;
};
